export default __webpack_public_path__ + "static/media/10.633a3685.jpg";